import { TrashIcon } from '@heroicons/react/solid';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, PrefixInput } from '@/components/inputs';
import { DataSourceCodeConfig, TDataSource } from '@/models/dataSource';
import { useDeleteRuleMutation } from '@/services/endpoints/rules';
import TrackRuleForm from './TrackRuleForm';
import { ITrackPageVisitEvents } from '@/features/dataSourceEdit/types';
import { useWorkspace } from '@/features/workspaces/hooks';
import { TrackPageVisitPanel } from '../../createDataSource/createDataSourceContent/dataSourceTypes/code/commons/tracking';
import { TrackPageVisit } from '@/features/dataSourceEdit/components/categories/code/tracking';

type TrackPageVisitViewProps = {
  dataSource?: TDataSource<DataSourceCodeConfig>;
  events: ITrackPageVisitEvents[];
  className?: string;
};

export const TrackPageVisitView: FunctionComponent<TrackPageVisitViewProps> = ({ dataSource, events, className }) => {
  const { t } = useTranslation('data_source_edit');
  const workspace = useWorkspace();

  const [deleteRule] = useDeleteRuleMutation();

  const handleDeleteRule = (ruleId: string) => {
    if (ruleId && dataSource && workspace) {
      deleteRule({
        workspaceId: workspace.id,
        ruleId,
        dataSourceId: dataSource.id,
      });
    }
  };

  return (
    <TrackPageVisitPanel className={className}>
      <div className='mt-4'>
        {events?.map((event) => (
          <div key={event.identifier} className='my-2 flex px-4'>
            <div className='w-1/2 flex-auto'>
              <PrefixInput value={event.pagePath} prefix={event.baseUrl} isViewMode={true} />
            </div>
            <div className='flex w-1/2'>
              <span className='ml-2 mr-1 py-2'>{t('code.track_events.creates')}</span>
              <div className='flex-auto'>
                <Input placeholder={t('code.track_events.name_of_the_event')} value={event.eventName} isViewMode={true} />
              </div>
              <div className='flex items-center'>
                <TrashIcon className={'ml-3 size-6 cursor-pointer text-red-500 hover:text-red-900'} onClick={() => handleDeleteRule(event.id)} />
              </div>
            </div>
          </div>
        ))}
      </div>

      <TrackRuleForm dataSource={dataSource} currentEventCount={events?.length || 0} newEventCountFn={(values) => values.pageVisitEvents.length}>
        {({ values, setFieldValue, setFieldError, errors }) => {
          return (
            <TrackPageVisit
              values={values}
              handleSetFieldValue={setFieldValue}
              handleSetFieldError={setFieldError}
              handleDeleteRule={handleDeleteRule}
              errors={errors}
              dataSource={dataSource}
            />
          );
        }}
      </TrackRuleForm>
    </TrackPageVisitPanel>
  );
};
